
import { Component, Vue } from 'vue-property-decorator'
import { DicDetail } from '@/types/dictionary'

@Component({
  name: 'DicList'
})
export default class extends Vue {
  private searchInfo = {
    dicType: '',
    dicTypeDesc: '',
    dicValue: ''
  }

  private dataList: Array<DicDetail> = []
  private loading = false
  private total = 0
  private page = 1
  private size = 10

  created () {
    this.getData()
  }

  getData () {
    this.loading = true
    this.$axios.get<{ total: number; list: Array<DicDetail> }>(this.$apis.dictionary.selectDicByPage, {
      ...this.searchInfo,
      page: this.page,
      size: this.size
    }).then((res) => {
      this.dataList = res.list || []
      this.total = res.total || 0
    }).finally(() => {
      this.loading = false
    })
  }

  onSearch () {
    this.page = 1
    this.getData()
  }

  // 新增
  add () {
    this.$router.push({
      name: 'dicAdd'
    })
  }

  // 编辑
  edit (dicId: string) {
    this.$router.push({
      name: 'dicEdit',
      params: { dicId }
    })
  }

  // 激活
  refresh () {
    this.$axios.get(this.$apis.dictionary.synchro, {}).then(() => {
      this.$message.success('刷新成功')
    })
  }
}
